import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { interval, Observable, startWith, switchMap } from 'rxjs';
import { API_URL } from '../models/api-url.token';
import { ISyncStatusVm } from '../sync-status-vm.model';
import { IStartSyncIm } from '../start-sync-im.model';
import { IStartSyncInputModel } from '../start-sync-input-model.model';
@Injectable({ providedIn: 'root' })
export class SyncUsersQuestionsService {
  private readonly baseUrl: string;
  constructor(private http: HttpClient, @Inject(API_URL) private apiUrl: string) {
    this.baseUrl = `${this.apiUrl}/SyncUsersQuestions`;
  }
  get(): Observable<ISyncStatusVm> {
    const headers = this.createHeaders();
    let params = new HttpParams();
    return this.http.get<ISyncStatusVm>(this.baseUrl+'/status', { headers, params });
  }
  postStart(input: IStartSyncInputModel): Observable<boolean> {
    const headers = this.createHeaders();
    return this.http.post<boolean>(this.baseUrl+'/start', input, { headers });
  }
  postStop(): Observable<any> {
    const headers = this.createHeaders();
    return this.http.post<any>(this.baseUrl+'/stop', null, { headers });
  }
  
  pollStatus(intervalMs: number = 20000): Observable<ISyncStatusVm> {
    return interval(intervalMs).pipe(
      startWith(0),
      switchMap(() => this.get())
    );
  }
  
  private createHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    const token = localStorage.getItem('authToken');
    if (token) headers = headers.set('Authorization', `Bearer ${token}`);
    return headers;
  }
}
